//api.js
import  { request } from './request'
//获取下载地址
export function address(params) {
  return request({
    url: 'version/list',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/axios/api.js